var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreMenuInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C11.5837 19.5 11.2397 19.3576 10.9411 19.0589C10.6424 18.7603 10.5 18.4163 10.5 18C10.5 17.5837 10.6424 17.2397 10.9411 16.9411C11.2397 16.6424 11.5837 16.5 12 16.5C12.4163 16.5 12.7603 16.6424 13.0589 16.9411C13.3576 17.2397 13.5 17.5837 13.5 18C13.5 18.4163 13.3576 18.7603 13.0589 19.0589C12.7603 19.3576 12.4163 19.5 12 19.5ZM12 13.5C11.5837 13.5 11.2397 13.3576 10.9411 13.0589C10.6424 12.7603 10.5 12.4163 10.5 12C10.5 11.5837 10.6424 11.2397 10.9411 10.9411C11.2397 10.6424 11.5837 10.5 12 10.5C12.4163 10.5 12.7603 10.6424 13.0589 10.9411C13.3576 11.2397 13.5 11.5837 13.5 12C13.5 12.4163 13.3576 12.7603 13.0589 13.0589C12.7603 13.3576 12.4163 13.5 12 13.5ZM12 7.5C11.5837 7.5 11.2397 7.35759 10.9411 7.05895C10.6424 6.7603 10.5 6.41634 10.5 6C10.5 5.58366 10.6424 5.2397 10.9411 4.94105C11.2397 4.64241 11.5837 4.5 12 4.5C12.4163 4.5 12.7603 4.64241 13.0589 4.94105C13.3576 5.2397 13.5 5.58366 13.5 6C13.5 6.41634 13.3576 6.7603 13.0589 7.05895C12.7603 7.35759 12.4163 7.5 12 7.5Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreMenuInactive);
export default __webpack_public_path__ + "static/media/more-menu-inactive.1f075ca402cc8bae75257b869a765c5f.svg";
export { ForwardRef as ReactComponent };